// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outline-table-outlineCard-WPxjg {
  height: 100%;
  overflow: hidden;
}

.outline-table-container-AHC26 {
  padding-left: 16px;
  padding-right: calc(16px - var(--scroll-width));
  overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/outline-table/outline-table.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;AACpB","sourcesContent":[".outlineCard {\n  height: 100%;\n  overflow: hidden;\n}\n\n.container {\n  padding-left: 16px;\n  padding-right: calc(16px - var(--scroll-width));\n  overflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outlineCard": `outline-table-outlineCard-WPxjg`,
	"container": `outline-table-container-AHC26`
};
export default ___CSS_LOADER_EXPORT___;
